import { useSelector } from 'react-redux';
import NkfAecButton from './components/web/NkfAecButton';
import NkfForceBypassButton from './components/web/NkfForceBypassButton';
import NkfJankButton from './components/web/NkfJankButton';
import NkfMakeupGainButton from './components/web/NkfMakeupGainButton';
import NkfTxMeterButton from './components/web/NkfTxMeterButton';
import NkfLogButton from './components/web/NkfLogButton';
import NkfMediaStatsButton from './components/web/NkfMediaStatsButton';
import NkfSpeakerButton from './components/web/NkfSpeakerButton';
import { isNkfAecButtonEnabled, isNkfJankButtonEnabled } from './functions';
const nkfAec = {
    key: 'nkf-aec',
    Content: NkfAecButton,
    group: 2
};
const nkfSpeaker = {
    key: 'nkf-speaker',
    Content: NkfSpeakerButton,
    group: 2
};
const nkfLog = {
    key: 'nkf-log',
    Content: NkfLogButton,
    group: 5
};
const nkfJank = {
    key: 'nkf-jank',
    Content: NkfJankButton,
    group: 5
};
const nkfMediaStats = {
    key: 'nkf-media-stats',
    Content: NkfMediaStatsButton,
    group: 5
};
const nkfForceBypass = {
    key: 'nkf-force-bypass',
    Content: NkfForceBypassButton,
    group: 5
};
/**
 * Hook returning the NKF-AEC (echo cancellation) toolbar button when the AEC
 * engine is enabled via config, undefined otherwise.
 *
 * @returns {Object|undefined}
 */
export function useNkfAecButton() {
    const enabled = useSelector(isNkfAecButtonEnabled);
    if (enabled) {
        return nkfAec;
    }
}
/**
 * Hook returning the "スピーカー" toolbar button (NKF-AEC debug waveform overlay
 * toggle) when the AEC engine is enabled via config, undefined otherwise.
 *
 * @returns {Object|undefined}
 */
export function useNkfSpeakerButton() {
    const enabled = useSelector(isNkfAecButtonEnabled);
    if (enabled) {
        return nkfSpeaker;
    }
}
/**
 * Hook returning the "ログ" toolbar button (NKF-AEC debug LOG panel toggle) when
 * the AEC engine is enabled via config, undefined otherwise. Kept out of
 * MAIN_TOOLBAR_BUTTONS_PRIORITY so it lands in the 詳細な操作 (overflow) menu.
 *
 * @returns {Object|undefined}
 */
export function useNkfLogButton() {
    const enabled = useSelector(isNkfAecButtonEnabled);
    if (enabled) {
        return nkfLog;
    }
}
/**
 * Hook returning the main-thread jank button (debug tool for reproducing the
 * transmitted-audio dropouts) when config.nkfAec.jankButton is true, undefined
 * otherwise. Kept in the 詳細な操作 (overflow) menu.
 *
 * @returns {Object|undefined}
 */
export function useNkfJankButton() {
    const enabled = useSelector(isNkfJankButtonEnabled);
    if (enabled) {
        return nkfJank;
    }
}
/**
 * Hook returning the "メディア計測" toolbar button when the AEC engine is
 * enabled via config, undefined otherwise. Kept in the 詳細な操作 (overflow)
 * menu alongside the other debug views.
 *
 * @returns {Object|undefined}
 */
export function useNkfMediaStatsButton() {
    const enabled = useSelector(isNkfAecButtonEnabled);
    if (enabled) {
        return nkfMediaStats;
    }
}
/**
 * Hook returning the forced-bypass button (debug tool for reproducing the
 * processed/raw alternation) when config.nkfAec.jankButton is true, undefined
 * otherwise. Shares the jank flag: both are debug-build only.
 *
 * @returns {Object|undefined}
 */
export function useNkfForceBypassButton() {
    const enabled = useSelector(isNkfJankButtonEnabled);
    if (enabled) {
        return nkfForceBypass;
    }
}
const nkfMakeupGain = {
    key: 'nkf-makeup-gain',
    Content: NkfMakeupGainButton,
    group: 5
};
/**
 * 音量の自動調整ボタン。表示の可否は config.js の toolbarButtons 許可リストが決める。
 *
 * @returns {Object}
 */
export function useNkfMakeupGainButton() {
    return nkfMakeupGain;
}
const nkfTxMeter = {
    key: 'nkf-tx-meter',
    Content: NkfTxMeterButton,
    group: 5
};
/**
 * 送信メーターのボタン。表示の可否は config.js の toolbarButtons 許可リストが決める。
 *
 * @returns {Object}
 */
export function useNkfTxMeterButton() {
    return nkfTxMeter;
}
